import { LoaderFunction, Outlet } from 'react-router-dom';
import { api } from '../../../utils/fetchApi';
import {
  generateResolverTasksAPIUrl,
  generateWizardStepTasksAPIUrl,
  isResolverType,
  saveCallbackUrlFromLoader,
} from '../utils';

export const loader: LoaderFunction = async ({ request, params }) => {
  const { locationId, resolverType, wizardSlug, wizardStepSlug, categoryType } =
    params;

  saveCallbackUrlFromLoader({ request, params });

  if (wizardSlug && wizardStepSlug) {
    return api(
      generateWizardStepTasksAPIUrl(wizardSlug, wizardStepSlug, locationId),
    );
  }

  let resolvedResolverType = null;

  if (resolverType) {
    if (isResolverType(resolverType)) {
      resolvedResolverType = resolverType;
    } else {
      throw new Error(`Invalid resolver type: ${resolverType}`);
    }
  }

  return api(
    generateResolverTasksAPIUrl(
      resolvedResolverType,
      locationId,
      categoryType,
      true,
    ),
  );
};

export const Component = () => {
  return <Outlet />;
};
